export default __webpack_public_path__ + "static/media/Players.5aeea5d2.svg";